import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  height: 4.5rem;
  flex-direction: row;
  list-style-type: none;
  padding: 0.5em;
  .avatar--skeleton{
    display: flex;
    width:4rem;
    height:3.65rem;
    justify-content: center;
    align-items: center;
    span{
      display: flex;
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
      position: relative;
      background-color:#e9ecef; 
      &::before{
        border-radius: 50%;
        position: absolute;
        content: "";
        height: 100%;
        width: 100%;
        background-image: linear-gradient(to right, #e9ecef 0%, rgba(0,0,0,0.05) 20%, #e9ecef 40%, #e9ecef 100%);
        background-repeat: no-repeat;
        background-size: 450px 400px;
        animation: shimmer 1.5s linear infinite;
      }
    }
  }
  .info--skeleton{
    display: flex;
    width: calc(100% - 3rem);
    max-width: calc(100% - 3rem);
    flex-direction: column;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    .name--skeleton{
      display: flex;
      width: 100%;
      height: 50%;
      justify-content: center;
      align-items: center;
    }
    .description--skeleton{
      display: flex;
      width: 100%;
      height: 50%;
      justify-content: center;
      align-items: center;
      border-bottom: 1px solid #eee;
    }
    span{
      width: 100%;
      height: 1rem;
      position: relative;
      background-color:#e9ecef; 
      border-radius: 2px;
      ::before{
        position: absolute;
        border-radius: 2px;
        content: "";
        height: 100%;
        width: 100%;
        background-image: linear-gradient(to right, #e9ecef 0%, rgba(0,0,0,0.05) 20%, #e9ecef 40%, #e9ecef 100%);
        background-repeat: no-repeat;
        background-size: 450px 400px;
        animation: shimmer 1.5s linear infinite;
      }
    }
  }
  
  @keyframes shimmer {
    0%{
      background-position: -450px 0;
    }
    100%{
      background-position: 450px 0;
    }
  }
`
